/*@ngInject*/
const LoginController = function ($scope, $state, $rootScope, $uibModal, $location, $stateParams, $timeout, appTypeConfigurationModel, authorizationConstants, coreConstant, coreMediator, localization, uiPerformanceLoggerConstant, authenticationMediator) {

    var consoleTypeAuthorizationName = authorizationConstants.LOGIN_UNDERWRITER_WORKSTATION,
        timeoutList = [];

    localization.setupLocale('auth', require('./login.i18n.json'));

    $scope.viewModel = {
        loginForm: null,
        revisionNumber: null,
        displayForgotPassword:false,
        loginTitle:null
    };

    timeoutList.push($timeout(() => {
        if (!_.isNil($stateParams.username)) {
            $scope.userName = $stateParams.username;

            $scope.$emit(coreConstant.event.ADVANCE_FOCUS, '.passwordInput');
        } else {
            $scope.$emit(coreConstant.event.ADVANCE_FOCUS, '.usernameInput');
        }
    }, 0));

    $scope.errorElement = '.usernameInput';

    function loadRevision() {
        coreMediator.getRevision().then(function (result) {
            $scope.viewModel.revisionNumber = result.revNumber;
        });
    }

    $scope.login = () => {
        let usernameIsValid = $scope.viewModel.loginForm.email.$valid,
            passwordIsValid = $scope.viewModel.loginForm.password.$valid,
            isFormValid = usernameIsValid && passwordIsValid,
            action = uiPerformanceLoggerConstant.LOGIN,
            message = '';

        function showErrorModal(message) {
            let modalInstance = $uibModal.open({
                templateUrl: '/ui/modal/errorModal/errorModal.tpl.html',
                controller: 'errorModalController',
                windowClass: 'genericErrorModal',
                backdrop: 'static',
                resolve: {
                    options: {
                        title: i18n.t('auth|login.messages.genericErrorTitle'),
                        message: message,
                        okButtonLabel: i18n.t('auth|login.okButtonLabel')
                    }
                }
            });
        }

        function handleLoginSuccess() {
            $rootScope.$broadcast(coreConstant.event.BOOT_APPLICATION);
        }

        function handleError(error) {
            let action = uiPerformanceLoggerConstant.LOGIN,
                status = coreConstant.uiPeformanceLogger.FAIL;

            // If there was an error logging into the application, we need to end the ui performance log to clean
            // it up, but we don't want to send a request to the server to log the failure, because we aren't
            // authenticated...obviously :)
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG_WITHOUT_LOGGING, action, status);
            $scope.$emit(coreConstant.event.ADVANCE_FOCUS, '.usernameInput');
        }

        if (isFormValid) {
            if (appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_AGENT) {
                consoleTypeAuthorizationName = authorizationConstants.LOGIN_AGENT_WORKSPACE;
            } else if (appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO) {
                consoleTypeAuthorizationName = authorizationConstants.LOGIN_CONFIGURATOR;
            }

            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
            coreMediator.login($scope.userName, $scope.password, coreConstant.authorization.INITIAL_TOKEN_TIMEOUT_SECONDS).then(handleLoginSuccess, handleError);
        } else {
            $scope.errorElement = !usernameIsValid ? '.usernameInput' : '.passwordInput';

            if (!usernameIsValid && !passwordIsValid) {
                message = i18n.t('auth|login.messages.userNamePasswordError');
            } else if (!usernameIsValid) {
                message = i18n.t('auth|login.messages.userNameError');
            } else if (!passwordIsValid) {
                message = i18n.t('auth|login.messages.passwordError');
            }

            showErrorModal(message);
        }

    };

    $scope.$on(coreConstant.event.EXPIRED_PASSWORD, (event) => {
        $state.go('password', {
            username: $scope.userName,
            messageKey: 'auth|changePassword.expiredPassword'
        });
    });

    const absoluteUrl = $location.absUrl().toLowerCase();

    if(_.includes(absoluteUrl, 'umagent')) {
        $rootScope.title =  i18n.t('auth|login.umAgentPageTitle');
        $scope.loginTitle = i18n.t('auth|login.umAgentFormTitle');
    } else if (_.includes(absoluteUrl, 'umstudio')) {
        $rootScope.title =  i18n.t('auth|login.umStudioPageTitle');
        $scope.loginTitle = i18n.t('auth|login.umStudioFormTitle');
    } else if (_.includes(absoluteUrl, 'appreader')) {
        $rootScope.title =  i18n.t('auth|login.appReaderPageTitle');
        $scope.loginTitle = i18n.t('auth|login.appReaderFormTitle');
    } else {
        $rootScope.title =  i18n.t('auth|login.uwPageTitle');
        $scope.loginTitle = i18n.t('auth|login.uwFormTitle');
    }

    $scope.forgotPassword = () => {
        authenticationMediator.showForgotPassword();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSED, (event) => {
        $scope.$emit(coreConstant.event.ADVANCE_FOCUS, $scope.errorElement);
    });

    $scope.$on('$destroy', () => {
        _.each(timeoutList, (item) => {
            $timeout.cancel(item);
        });
    });

    loadRevision();

    coreMediator.loadDefaultPreferences().then(function (preferences) {
        if ((appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_AGENT && preferences['system.disablePasswordAndProfileManagementAgent'].value === 'false') ||
            (appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM && preferences['system.disablePasswordAndProfileManagementUnderwriter'].value === 'false') ||
            (appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO && preferences['system.disablePasswordAndProfileManagementConfigurator'].value === 'false')) {
            $scope.viewModel.displayForgotPassword = true;
        }
    }.bind(this));
};

angular.module('gw-um-auth')
    .controller('loginController', LoginController);
